import qs from 'qs';

/**
 * Generate url for recommendation request
 * @param {string} slotId - identifier of slot
 * @param {number} pageSize - limit items fetched
 * @param {array} [seedItemIds] - item list that will act as seed for recommendation
 */
const recommendationsRequestBuilder = (
    slotId,
    pageSize,
    shippingCountryCode,
    seedItemIds = []
) => {
    const endpoint = '/api/webapi/discover/recommendations-v4';

    return (pageIndex = 0) => {
        let queryParameters = {
            slot: slotId,
            maxResults: pageSize,
            pageNumber: pageIndex,
            shippingCountryCode
        };

        if (!!seedItemIds && seedItemIds.length > 0) {
            queryParameters.seedItemIds = seedItemIds;
        }

        return `${endpoint}?${qs.stringify(queryParameters, {
            arrayFormat: 'repeat'
        })}`;
    };
};

/**
 * Generate url for similar items request
 * @param {number} id - id of item to find similar to
 * @param {number} pageSize - limit items fetched
 */
const similarItemsRequestBuilder = (id, pageSize) => {
    const endpoint = '/ma/recommendations-similar-items';
    return () => {
        let queryParameters = {
            id,
            pageSize
        };
        return `${endpoint}?${qs.stringify(queryParameters)}`;
    };
};

/**
 * Generate url for similar items request
 * @param {number} id - id of item to find similar to
 * @param {number} pageSize - limit items fetched
 */
const similarItemsFromShopRequestBuilder = (id, pageSize) => {
    const endpoint = '/ma/recommendations-similar-items-from-shop';
    return () => {
        let queryParameters = {
            id,
            pageSize
        };
        return `${endpoint}?${qs.stringify(queryParameters)}`;
    };
};

const similarItemsFromCampaignRequestBuilder = (
    itemId,
    size,
    query,
    campaignCodeId
) => {
    const endpoint = '/ma/recommendations-more-items-from-campaign';
    return () => {
        let queryParameters = {
            itemId,
            size,
            query,
            campaignCodeId
        };
        return `${endpoint}?${qs.stringify(queryParameters)}`;
    };
};

export {
    recommendationsRequestBuilder,
    similarItemsRequestBuilder,
    similarItemsFromShopRequestBuilder,
    similarItemsFromCampaignRequestBuilder
};
